"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainContent = void 0;
var _react = require("react");
var _Modal = require("../../Layout/Modal");
var _SliderLayout = require("../../Layout/SliderLayout");
var _useAudiencePickerProvider = require("../AudiencePicker/provider/useAudiencePickerProvider");
var _TaskManager = require("./TaskManager.provider");
var _carrouselItems = require("./carrouselItems");
var _useCurrentIndex = require("./hooks/useCurrentIndex");
var _useUnitData = require("./hooks/useUnitData");
var _hooks = require("../../hooks");
var _useMessages = require("./hooks/useMessages");
var _Preloader = require("../../UI/Preloader");
var _TaskManager2 = _interopRequireDefault(require("./TaskManager.styles"));
var _useItem = require("./hooks/useItem");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MainContent = props => {
  const {
    environmentID,
    audienceID,
    itemID,
    taskID,
    layout = 'popup',
    onClose,
    onStatusChange,
    itemLanguage,
    kotarParams,
    minDate,
    maxDate,
    isChangeAudienceAfterSubmitEnabled = false,
    isNoAudienceEnabled = false,
    isAssignedTaskUrlEnabled = true,
    isLearningActivity = false,
    shareItemUrl,
    supportUrl,
    isNmm
  } = props;
  const {
    isSessionDataReady,
    userId
  } = (0, _hooks.useSessionData)();
  const {
    viewHeight
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const styles = (0, _TaskManager2.default)();
  const {
    isPopupOpen,
    setIsPopupOpen,
    setIsChanged,
    task,
    setShowReadOnlyMessageGroups,
    readOnlyGroups,
    readOnlyStudents,
    selectedGroups,
    selectedStudents,
    isGroupsReadOnly,
    onCloseData,
    isUnitDataLoading,
    isTaskLoading,
    isCloneItem,
    isSavingItem,
    getLabel
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const handleChanged = () => {
    setIsChanged(true);
  };
  const handleDisabledItemClick = () => {
    let message = null;
    if (task && !task.isReadOnly && task.cannotModifyMembers) {
      message = getLabel('message_groupsSelector_cant_remove');
      setShowReadOnlyMessageGroups(message);
    }
    return message;
  };
  const handleDeleteItem = () => {
    let message = null;
    if (task && !task.isReadOnly && task.cannotModifyMembers && isChangeAudienceAfterSubmitEnabled) {
      message = getLabel('message_remove_students_from_audience');
    }
    return message;
  };
  const handleClose = () => {
    setIsPopupOpen(false);
    if (onClose) {
      onClose(onCloseData);
    }
  };
  const audiencePickerProvider = (0, _useAudiencePickerProvider.useAudiencePickerProvider)({
    onChanged: handleChanged,
    onDisableItemClick: handleDisabledItemClick,
    onDeleteItem: handleDeleteItem,
    onClose: handleClose,
    isReadOnly: isGroupsReadOnly,
    readOnlyGroups: readOnlyGroups,
    readOnlyStudents: readOnlyStudents,
    selectedGroups: selectedGroups,
    selectedStudents: selectedStudents,
    // isEditGroupEnabled: isEditGroupEnabled,
    environmentID: environmentID,
    audienceID: audienceID,
    fullHeight: `calc(${viewHeight + 'px'} - ${pxToRem(62)})`
  });
  const {
    getCurrentIndex
  } = (0, _useCurrentIndex.useCurrentIndex)(audiencePickerProvider, isNoAudienceEnabled, itemID, taskID, onStatusChange);
  const currentIndex = getCurrentIndex();
  const {
    initUnitData
  } = (0, _useUnitData.useUnitData)();
  (0, _react.useEffect)(() => {
    initUnitData();
  }, [initUnitData]);
  (0, _useMessages.useMessages)(); //todo: fix messages

  const {
    getItem
  } = (0, _useItem.useItem)(itemID, itemLanguage, environmentID, audienceID, taskID, kotarParams, minDate, maxDate, isChangeAudienceAfterSubmitEnabled, isLearningActivity);
  (0, _react.useEffect)(() => {
    getItem();
  }, [getItem]);
  (0, _react.useEffect)(() => {
    if (layout === 'popup') {
      setIsPopupOpen(true);
    }
  }, [layout, setIsPopupOpen]);
  if (!(isSessionDataReady && userId)) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-TaskManager'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      isOpen: isPopupOpen,
      isCloseFromOutsideEnabled: false,
      type: audiencePickerProvider.isErrorMessage || currentIndex === 9 ? 'alert' : currentIndex === 7 || currentIndex === 8 ? 'success' : undefined,
      layout: layout,
      onClose: handleClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderLayout.SliderLayout, {
        width: "100%",
        index: currentIndex,
        items: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.ItemSelect, {
          ...props
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Main, {
          ...props,
          handleClose: handleClose,
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Audience, {
          view: "groupsSelector",
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Audience, {
          view: "studentsSelector",
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Audience, {
          view: "createGroup",
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Audience, {
          view: "groupEdit",
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.EditTask, {
          isLearningActivity: isLearningActivity
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.SavingTask, {
          isAssignedTaskUrlEnabled: isAssignedTaskUrlEnabled,
          handleClose: handleClose,
          audiencePickerProvider: audiencePickerProvider
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.ShareTask, {
          isLearningActivity: isLearningActivity,
          shareItemUrl: shareItemUrl,
          handleClose: handleClose
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Error, {
          ...props,
          handleClose: handleClose
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Alert, {
          type: "updateTaskTypeAfterExamStart"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Alert, {
          type: "reSubmitTaskAfterTaskTypeChanged"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_carrouselItems.Alert, {
          type: "noAudience",
          handleClose: handleClose,
          isNmm: isNmm,
          supportUrl: supportUrl
        })],
        children: (isUnitDataLoading || isTaskLoading || isCloneItem || isSavingItem || !audiencePickerProvider.isAudiencePickerProviderReady) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Preloader.Preloader, {
          type: "over",
          width: 300
        })
      })
    })
  });
};
exports.MainContent = MainContent;